import fieldSchemaOrig from 'volto-form-block-original/fieldSchema';

const fielSchema = (props) => {
  const schema = fieldSchemaOrig(props);
  schema.properties.required.widget = 'random_suffix_checkbox_widget';
  return schema;
};

export default fielSchema;
